import React from 'react'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function StaffOutletTemplate({
  viewOnly = false,
  ratingData,
  onChange,
  submittedRating,
}) {
   const getTotalRating = () => {
    const {
      punctuality,
      devotion_to_duty,
      team_spirit,
      client_handling,
      successful_leads,
      complaint_handling,
      customer_services,
      maintaining_of_record,
      maintenance_of_outlets,
      display_of_products,
    } = ratingData

    let total =
      parseInt(punctuality) +
      parseInt(devotion_to_duty) +
      parseInt(team_spirit) +
      parseInt(client_handling) +
      parseInt(successful_leads) +
      parseInt(complaint_handling) +
      parseInt(customer_services) +
      parseInt(maintaining_of_record) +
      parseInt(maintenance_of_outlets) +
      parseInt(display_of_products)
    return total
  }

  const getSubmittedRating = () => {
    const {
      punctuality,
      devotion_to_duty,
      team_spirit,
      client_handling,
      successful_leads,
      complaint_handling,
      customer_services,
      maintaining_of_record,
      maintenance_of_outlets,
      display_of_products,
    } = submittedRating

    let total =
      parseInt(punctuality) +
      parseInt(devotion_to_duty) +
      parseInt(team_spirit) +
      parseInt(client_handling) +
      parseInt(successful_leads) +
      parseInt(complaint_handling) +
      parseInt(customer_services) +
      parseInt(maintaining_of_record) +
      parseInt(maintenance_of_outlets) +
      parseInt(display_of_products)
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Rating</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            <tr>
              <td>
                <strong>Punctuality</strong>
              </td>
              <td>{submittedRating.punctuality}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.punctuality}
                  onChange={(value) => onChange('punctuality', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.punctuality}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Devotion to Duty</strong>
              </td>
              <td>{submittedRating.devotion_to_duty}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.devotion_to_duty}
                  onChange={(value) => onChange('devotion_to_duty', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.devotion_to_duty}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Team Spirit</strong>
              </td>
              <td>{submittedRating.team_spirit}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.team_spirit}
                  onChange={(value) => onChange('team_spirit', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.team_spirit}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Client handling</strong>
              </td>
              <td>{submittedRating.client_handling}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.client_handling}
                  onChange={(value) => onChange('client_handling', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.client_handling}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Successful leads / orders</strong>
              </td>
              <td>{submittedRating.successful_leads}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.successful_leads}
                  onChange={(value) => onChange('successful_leads', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.successful_leads}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Complaint handling</strong>
              </td>
              <td>{submittedRating.complaint_handling}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.complaint_handling}
                  onChange={(value) => onChange('complaint_handling', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.complaint_handling}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Customer Services</strong>
              </td>
              <td>{submittedRating.customer_services}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.customer_services}
                  onChange={(value) => onChange('customer_services', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.customer_services}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Closing/maintaining of record </strong>
              </td>
              <td>{submittedRating.maintaining_of_record}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.maintaining_of_record}
                  onChange={(value) => onChange('maintaining_of_record', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.maintaining_of_record}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Maintenance of outlets</strong>
              </td>
              <td>{submittedRating.maintenance_of_outlets}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.maintenance_of_outlets}
                  onChange={(value) => onChange('maintenance_of_outlets', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.maintenance_of_outlets}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Display of Products</strong>
              </td>
              <td>{submittedRating.display_of_products}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.display_of_products}
                  onChange={(value) => onChange('display_of_products', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.display_of_products}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / 110</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / 110</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
